import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchCurrentQuestion, resetPassword } from "../../../domain/auth/authActions";
import PasswordForgotForm from "../../forms/public/PasswordForgotForm";
import StatusMessage from "../../presentational/StatusMessage";
import * as StatusMessages from "../../../constants/StatusMessages";
import { FormattedMessage } from "react-intl";
import isAxiosError from "assets/scripts/utils/isAxiosError";
import track from "react-tracking";
import "./Registration/Registration.module.less";
export const Requirements = (props) => (<ul {...props}>
		<li>
			<FormattedMessage id="passwordForgot.requirements.noReuse" defaultMessage="Cannot reuse previous password"/>
		</li>
		<li>
			<FormattedMessage id="passwordForgot.requirements.upper" defaultMessage="One upper case letter"/>
		</li>
		<li>
			<FormattedMessage id="passwordForgot.requirements.lower" defaultMessage="One lower case letter"/>
		</li>
		<li>
			<FormattedMessage id="passwordForgot.requirements.number" defaultMessage="One number"/>
		</li>
		<li>
			<FormattedMessage id="passwordForgot.requirements.special" defaultMessage="One special character"/>
		</li>
		<li>
			<FormattedMessage id="passwordForgot.requirements.length" defaultMessage="10 characters minimum"/>
		</li>
	</ul>);
class PasswordForgot extends Component {
    componentDidMount() {
        const { userId, token } = this.props.location.query;
        if (userId != null && token != null) {
            this.props.fetchCurrentQuestion(userId, token);
        }
    }
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        const { props } = this;
        const { currentQuestion, authError } = props;
        const { userId, token } = props.location.query;
        const invalidToken = isAxiosError(authError) && authError.response.status === 410;
        return (<div className="wrapper">
				<div className="vr vr_x4">
					<h1 className="hdg js-pageHeader">
						<FormattedMessage id="passwordForgot.header" defaultMessage="Forgot Password"/>
					</h1>
				</div>

				<StatusMessage isError isActive={userId == null || token == null || (currentQuestion == null && invalidToken)} customMessage={StatusMessages.AUTH.PASSWORD_FORGOT_URL} domain="auth" willPersist/>

				<StatusMessage isError isActive={currentQuestion != null && authError != null} error={authError} customMessage={StatusMessages.AUTH.INTRO_PASSWORD_FORGOT} domain="auth" willPersist/>

				<StatusMessage isLoad isActive={props.authIsLoading}/>

				{currentQuestion != null && userId != null && token != null && (<div className="passwordContent">
						<div>
							<div className="vr vr_x5">
								<div className="text">
									<FormattedMessage tagName="p" id="passwordForgot.intro" defaultMessage="Please enter your security answer below to change your password."/>
								</div>
							</div>
							<div className="u-isVisuallyHidden">
								<h2>
									<FormattedMessage id="passwordForgot.requirements.header" defaultMessage="Password requirements:"/>
								</h2>
								<Requirements />
							</div>
							<div className="vr vr_x5">
								<PasswordForgotForm fieldErrors={this.props.authFieldErrors} resetPassword={this.props.resetPassword} securityQuestion={this.props.currentQuestion} token={token} userId={userId} isLoading={this.props.authIsLoading} locale={this.props.locale}/>
							</div>
						</div>
						<div className="marginTop7em">
							<StatusMessage isLoad isActive={this.props.authIsLoading ? true : false}/>
							<div aria-hidden="true">
								<div className="vr vr_x2">
									<h2 className="label">
										<FormattedMessage id="passwordForgot.requirements.header" defaultMessage="Password requirements:"/>
									</h2>
								</div>
								<div className="vr vr_x5">
									<div className="text">
										<Requirements className="listV listV_x3 mix-listV_bullet"/>
									</div>
								</div>
							</div>
						</div>
					</div>)}
			</div>);
    }
}
/* --- React Redux bootstrapping --- */
const mapStateToProps = (state) => ({
    authError: state.auth.error,
    authFieldErrors: state.auth.fieldErrors,
    authIsLoading: state.auth.isLoading,
    authIsSuccess: state.auth.isSuccess,
    currentQuestion: state.auth.currentQuestion,
    locale: state.i18n.locale
});
const bindActionsToProps = {
    fetchCurrentQuestion,
    resetPassword
};
/* Create and export container component that wraps PasswordForgot for property binding */
export default track({ page: "PasswordForgot" }, { dispatchOnMount: true })(connect(mapStateToProps, bindActionsToProps)(PasswordForgot));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/PasswordForgot.tsx